export const assistBarLongException = (state) => {
    if (state.sidePanel === "Included") {
        return "Not available with side panel";
    }
    return null;
};
